module.exports = __webpack_public_path__ + "static/media/materialize.98e7588d.png";